import React from 'react';
import { Home, FileText, Tag, ShoppingCart } from 'lucide-react';

// Barra de navegação inferior do cardápio público (telas home/promos/orders).
// Extraído VERBATIM de PublicMenu.js (Fase 2 refactor). Mantido como FUNÇÃO
// (chamado inline como {BottomNav({...})}, não como componente JSX) para preservar
// exatamente o comportamento de render inline do componente pai — ver comentário no
// call site do PublicMenu sobre evitar unmount/remount da subárvore.
const BottomNav = ({ currentScreen, navigateToScreen, cashbackData, getCartItemsCount }) => {
  if (currentScreen !== 'home' && currentScreen !== 'promos' && currentScreen !== 'orders') return null;

  return (
    <div className="bg-white border-t border-gray-200 p-2 fixed bottom-0 left-0 right-0 z-50">
      <div className="flex items-center justify-around">
        <button 
          onClick={() => navigateToScreen('home')}
          className={`flex flex-col items-center p-2 ${currentScreen === 'home' ? 'text-primary' : 'text-gray-600'}`}
          data-testid="bottom-nav-home"
        >
          <Home size={20} />
          <span className="text-xs mt-1">Início</span>
        </button>
        <button 
          onClick={() => navigateToScreen('orders')}
          className={`flex flex-col items-center p-2 ${currentScreen === 'orders' ? 'text-primary' : 'text-gray-600'}`}
          data-testid="bottom-nav-orders"
        >
          <FileText size={20} />
          <span className="text-xs mt-1">Pedidos</span>
        </button>
        
        {/* Botão Promos - Só aparece se cashback estiver habilitado */}
        {cashbackData && cashbackData.enabled && (
          <button 
            onClick={() => navigateToScreen('promos')}
            className={`flex flex-col items-center p-2 ${currentScreen === 'promos' ? 'text-primary' : 'text-gray-600'} relative`}
            data-testid="bottom-nav-promos"
          >
            <Tag size={20} />
            <span className="text-xs mt-1">Promos</span>
          </button>
        )}
        
        <button 
          onClick={() => navigateToScreen('cart')}
          className={`flex flex-col items-center p-2 relative ${currentScreen === 'cart' ? 'text-primary' : 'text-gray-600'}`}
          data-testid="bottom-nav-cart"
        >
          <ShoppingCart size={20} />
          <span className="text-xs mt-1">Carrinho</span>
          {getCartItemsCount() > 0 && (
            <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
              {getCartItemsCount()}
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default BottomNav;
